export default {
  BANK: { value: 0, title: "Банк" },
  CARD: { value: 1, title: "Картка" },
  CASH: { value: 2, title: "Готівка" },
};